import { render, staticRenderFns } from "./CreateConsignment.vue?vue&type=template&id=398184ac&scoped=true&"
import script from "./CreateConsignment.vue?vue&type=script&lang=js&"
export * from "./CreateConsignment.vue?vue&type=script&lang=js&"
import style0 from "./CreateConsignment.vue?vue&type=style&index=0&id=398184ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398184ac",
  null
  
)

export default component.exports